import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  generatePath,
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router";
import useTemplateInstance from "../../hooks/useTemplateInstance";
import {
  ACTIONS,
  createInstance,
} from "../../../../Providers/TemplateInstanceProvider";
import { usePictureSets } from "../../../hooks/usePictureSets";
import { usePriceList } from "../../../providers/PriceListProvider";
import useTemplate from "../../../../hooks/useTemplate";
import useRoutes from "../../../hooks/useRoutes";
import EditTemplateProduct from "../../Components/EditTemplateProduct/EditTemplateProduct";
import GreenScreenBackgroundsProvider from "../../Providers/GreenScreenBackgroundsProvider";
import { callAPI } from "../../../../lib/common";

export default () => {
  const { params } = useRouteMatch();
  const { currentPictureSet, isLoading } = usePictureSets();
  const [template, loadingTemplate] = useTemplate(params.templateUuid);
  const [templateData, setTemplateData] = useState(null);
  const { getProductByUuid } = usePriceList();
  const [state, dispatch] = useTemplateInstance();
  const routes = useRoutes();
  const history = useHistory();
  const routeParams = useParams();
  const subjectInitialized = useRef(false);

  console.log("Rendering create product page");

  useEffect(() => {
    if (!currentPictureSet || subjectInitialized.current) {
      return;
    }

    subjectInitialized.current = true;

    const postData = {
      template: {
        uuid: params.templateUuid,
      },
      subject: {
        uuid: currentPictureSet.subject.uuid,
      },
    };

    callAPI(
      "/api/webshop/user/templates/fill-template",
      "POST",
      postData,
    ).then((templateData) => {
      setTemplateData(templateData);
    });
  }, [params, currentPictureSet]);

  const product = useMemo(() => {
    return getProductByUuid(params.productUuid);
  }, [params.productUuid]);

  useEffect(() => {
    console.log("The product", product);
    if (!template || !templateData || !product) {
      return;
    }

    let instance = createInstance(
      template,
      templateData.userResources,
      templateData.year,
    );

    dispatch({
      type: ACTIONS.SET_TEMPLATE_INSTANCE,
      templateInstance: instance,
    });

    dispatch({
      type: ACTIONS.SET_PRODUCT,
      product: product,
    });
  }, [templateData, template, product]);

  const handleGoBack = () => {
    let path = "";
    if (template.type == "CALENDAR") {
      path = generatePath(routes["products.calendars"].path, {
        type: routeParams.type,
      });
    } else if (template.type == "CARD") {
      path = generatePath(routes["products.cards"].path, {
        type: routeParams.type,
      });
    } else {
      path = generatePath(routes["products.photogifts.category"].path, {
        type: routeParams.type,
        category: routeParams.category,
      });
    }
    history.push(path);
  };

  if (!state.template) {
    return <div>Loading</div>;
  }

  return (
    <GreenScreenBackgroundsProvider jobUuid={currentPictureSet.job.uuid}>
      <EditTemplateProduct handleGoBack={handleGoBack} mode="create" />
    </GreenScreenBackgroundsProvider>
  );
};
